export const heroSectionData = {
  topTitle: 'OUR BLOGS',
  title: 'The ZenAdmin Blogs',
  desc: 'Discover the latest insights and expert tips on IT administration',
  background: '#0D0D0E',
}
